import type { SurfaceProps } from './types';
import { surfaceFilled } from './types';

/** User Story surface: role → action → value + acceptance criteria rows. */
export function StoryForm({ spec, value, disabled, onChange }: SurfaceProps) {
  const role = String(value?.role ?? '');
  const action = String(value?.action ?? '');
  const val = String(value?.value ?? '');
  const ac = Array.isArray(value?.ac) ? (value!.ac as string[]) : ['', ''];

  const emit = (patch: Record<string, unknown>) => {
    const next = { role, action, value: val, ac, ...patch };
    onChange(next, surfaceFilled(spec, next));
  };
  const setAc = (i: number, v: string) => {
    const n = ac.slice();
    n[i] = v;
    emit({ ac: n });
  };

  return (
    <div className="surf surf-story" data-testid="surf-storyform">
      <div className="surf-tag">User Story · форма</div>
      <div className="story-row">
        <span className="pre">Как</span>
        <input value={role} disabled={disabled} placeholder="роль (покупатель, админ…)"
          onChange={(e) => emit({ role: e.target.value })} data-testid="story-role" />
      </div>
      <div className="story-row">
        <span className="pre">я хочу</span>
        <input value={action} disabled={disabled} placeholder="действие"
          onChange={(e) => emit({ action: e.target.value })} data-testid="story-action" />
      </div>
      <div className="story-row">
        <span className="pre">чтобы</span>
        <input value={val} disabled={disabled} placeholder="ценность · зачем это нужно"
          onChange={(e) => emit({ value: e.target.value })} data-testid="story-value" />
      </div>
      <div className="ac-h">Критерии приёмки</div>
      {ac.map((row, i) => (
        <div className="ac-row" key={i}>
          <span className="n">{i + 1}</span>
          <input value={row} disabled={disabled} placeholder="проверяемое условие"
            onChange={(e) => setAc(i, e.target.value)} />
          {ac.length > 1 && !disabled && (
            <button type="button" className="rm" aria-label="убрать критерий"
              onClick={() => emit({ ac: ac.filter((_, j) => j !== i) })}>×</button>
          )}
        </div>
      ))}
      {!disabled && (
        <button type="button" className="surf-add" onClick={() => emit({ ac: [...ac, ''] })}>
          + добавить критерий
        </button>
      )}
    </div>
  );
}
